import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, ButtonProps, Flex, Typography } from 'antd';

import CheckIcon from 'assets/images/icons/check.svg?react';
import ConnectIcon from 'assets/images/icons/connect.svg?react';
import VerifyIcon from 'assets/images/icons/firstSource/verificate.svg?react';
import OpenLinkIcon from 'assets/images/icons/open-link.svg?react';
import { EAdspaceStatus, IAdspace } from 'entities/Adspace';
import { useAddSourceMutation } from 'entities/Source';
import { useGetAppConfigQuery } from 'shared/api';

import styles from './AdsapceButtons.module.scss';

interface IAdsapceButtonsProps extends ButtonProps {
	adspace: Partial<IAdspace>;
}

export const AdsapceButtons: FC<IAdsapceButtonsProps> = ({ adspace, ...props }) => {
	const { t } = useTranslation();
	const { data: appConfig } = useGetAppConfigQuery();
	const { status, adspace_id, has_sources, source_can_be_created, mitgo_verify_url } = adspace;

	const [addSource, { isLoading, isSuccess }] = useAddSourceMutation();

	return (
		<>
			{status === EAdspaceStatus.VERIFIED && source_can_be_created && !has_sources && (
				<Button
					{...props}
					onClick={() => addSource({ adspace_id })}
					loading={isLoading}
					disabled={isLoading}
					type="primary"
					icon={<ConnectIcon />}
					block>
					{t('Подключить')}
				</Button>
			)}

			{status === EAdspaceStatus.VERIFIED && (has_sources || isSuccess) && (
				<Flex gap={8} align="center" justify="center" className={styles.connected}>
					<CheckIcon width={16} height={16} />
					<Typography.Text>{t('Подключено')}</Typography.Text>
				</Flex>
			)}

			{status === EAdspaceStatus.NOT_VERIFIED && mitgo_verify_url && (
				<Button
					{...props}
					href={`${mitgo_verify_url}&callback_url=${encodeURIComponent(window.location.href)}`}
					type="primary"
					icon={<VerifyIcon width={16} height={16} />}
					block>
					{t('Верифицировать')}
				</Button>
			)}

			{(status === EAdspaceStatus.DECLINED || status === EAdspaceStatus.DEACTIVATED) && appConfig?.adspaces_url && (
				<Button {...props} href={appConfig.adspaces_url} type="link" icon={<OpenLinkIcon />} iconPosition="end" block>
					{t('Открыть в Mitgo ID')}
				</Button>
			)}

			{status === EAdspaceStatus.CREATING && (
				<Typography.Paragraph
					ellipsis={{ rows: 2, tooltip: t('Мы создаём вашу платформу. Обычно это занимает несколько секунд...') }}
					style={{ margin: 0 }}>
					{t('Мы создаём вашу платформу. Обычно это занимает несколько секунд...')}
				</Typography.Paragraph>
			)}
		</>
	);
};
